import { useCallback } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectBankRedirectMethod } from '../../app/slices/configuration.slice';
import { selectSessionBankCode, selectSessionBankName } from '../../app/slices/bank.slice';
import { PSD2RedirectMethod } from '../../types/sdk';
import { selectRedirectionURL } from '../../app/slices/redirection.slice';

export const useRedirection = () => {
	const bankName = useAppSelector(selectSessionBankName) as string;
	const bankCode = useAppSelector(selectSessionBankCode) as string;
	const url = useAppSelector(selectRedirectionURL) as string;
	const bankRedirectMethod = useAppSelector(selectBankRedirectMethod);

	const redirectUser = useCallback(() => redirect(bankRedirectMethod, url), [bankRedirectMethod, url]);

	return { bankName, bankCode, bankRedirectMethod, redirectUser };
};

export function redirect(bankRedirectMethod: PSD2RedirectMethod, url: string) {
	const isSameWindow = bankRedirectMethod === 'sameWindow';
	if (isSameWindow) {
		const location = window.location;
		setTimeout(() => location.replace(url), 500);
	} else {
		window.open(url, '_blank');
	}
}
